/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import VariationCommission from '../../Step05/components/VariationCommission'
import VariationExcess from './VariationExcess'
import VariationOptions from './VariationOptions'
import BindContainer from '../../Step05/containers/BindContainer'
import IssueContainer from '../../Step05/containers/IssueContainer'
import PopUp from '../../../../common/PopUp/PopUp'
import { SpinnerIcon } from '../../../../../images/icons/Spinner/Spinner'
import { get } from 'lodash'

export default class Variation extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            commission: this.props.values.commission,
            excess: this.props.values.excess,
            optionsOpen: true,
            confirmRemove: false,
            confirmBind: false,
            dirtyVariationOption: false,
            viewIssuePopUp: false,
            confirmCancel: false,
            boundBind: false,
            boundTitle: '',
            boundError: '',
            boundPopupError: false,
        }
    }

    componentWillUpdate(nextProps: any, nextState: any) {
        if (nextProps !== this.props) {
            this.setState({
                commission: nextProps.values.commission,
                excess: nextProps.values.excess,
            })
        }
    }

    toggleOptionsOpen = () => this.setState({ optionsOpen: !this.state.optionsOpen })

    /**
     * Function to manage the change on Adjustments
     */
    handleAdjustChangecommission = (commission: any) => {

        let obj = this.props.values
        obj.commission = commission

        this.props.checkUpdate()
        this.props.updateQuoteVariation(this.props.quoteId, obj)

    }

    /**
     * Function to manage the change on Adjustments
     */
    handleAdjustChangeExcess = (excess) => {

        let obj = this.props.values
        // obj.excess = excess
        if (excess < (this.props.totalCollection / 2)) {
            // console.log(excess, this.props.values)
            obj.excess = Number(excess)
        } else {
            obj.excess = this.props.minExcession
        }
        this.props.checkUpdate()
        this.props.updateQuoteVariation(this.props.quoteId, obj)

    }

    /**
     * Function to manage the change on Options
     */
    handleAdjustChangeOptions = (obj: any) => {
        // const { editRenewal } = this.props
        // let objj = [obj]
        // const chObj = objj.map(({ inceptionDate, ...rest }) => ({ ...rest }))
        this.props.checkUpdate()
        this.props.updateQuoteVariation(this.props.quoteId, obj)
    }

    /**
     * Function to manage Issue button action to trigger confirmation popup
     */
    handleIssueButton = () => {
        this.setState({ confirmIssue: true })
    }
    /**
     * Function to manage Bind Action
     */
    handleBind = () => {
        // this.props.bindQuoteVariation(this.props.quoteId, this.props.values.id)
        if (this.props.editRenewal) {
            this.props.renewalBindQuoteVariation(this.props.values.policyId, this.props.values.id).
                then((response) => {
                    if (response.success !== false) {
                        this.setState({ boundBind: true, boundTitle: 'Renewals' })
                    }
                }).catch((response) => {
                    if (response.success === false) {
                        this.setState({
                            boundPopupError: true,
                            boundTitle: 'Renewals',
                            boundError: response.error,
                        })
                    }
                })

            // this.props.history.push('/renewals')
        } else {
            this.props.bindQuoteVariation(this.props.quoteId, this.props.values.id)
        }
    }

    /**
     * Function to manage Invite Action
     */
    handleInvite = () => {
        this.setState({ confirmInvite: false })
        this.props.inviteQuoteVariation(this.props.values.policyId, this.props.values.id).
            then((response) => {
                if (response.success !== false) {
                    this.setState({ viewIssuePopUp: true })
                }
            })
    }

    /**
     * Function to manage Bind Action
     */
    handleBindButton = () => {
        this.setState({ confirmBind: true })
    }

    triggerCheckSoftReferral = () => {
        this.props.checkSoftReferral(this.props.quoteId, this.props.values.id)
    }

    /**
     * Function to manage Remove Button
     */
    handleRemove = () => {
        // this.props.delQuoteVariation(this.props.quoteId, this.props.values.id)
        if (this.props.editRenewal) {
            this.props.history.push('/renewals')
        } else {
            this.props.delQuoteVariation(this.props.quoteId, this.props.values.id)
        }
    }

    /**
     * Get one of the possible values passed
     * as props and decide the position of the range slider
     */
    handleExcess = (value: number) => {
        const { minExcession, maxExcession } = this.props
        switch (value) {
            case minExcession: return 0
            case 1000: return 1
            case 2500: return 2
            case maxExcession: return 3
            default: return 0
        }
    }

    disableRemoveButton = () => {
        if (this.props.editRenewal) {
            return false
        } else {
            return (this.props.values.isIssued || this.props.loading)
        }
    }

    /**
     * Close all confirm popups
     */
    handleClosePopup = () => {
        // this.setState({ confirmRemove: false, confirmBind: false, confirmIssue: false })
        this.setState({
            confirmRemove: false,
            confirmBind: false,
            confirmIssue: false,
            confirmCancel: false,
        })
    }

    handleEndRoute = (endRoute: any) => {
        let changeRoute = endRoute.toLowerCase()
        this.setState({ boundBind: false, boundTitle: '', boundPopupError: false, boundError: '' })
        this.props.history ? this.props.history.push('/' + changeRoute) : window.location.href = `/${changeRoute}`
    }

    render() {

        const { checkStep04update = false, editRenewal, values } = this.props

        return (
            <div className="variation__block">

                {this.props.loading ? (
                    <div className="variation__loading">
                        <SpinnerIcon />
                    </div>
                ) : null}

                {(this.state.viewIssuePopUp) ?
                    <PopUp
                        title="Quote issued"
                        action={() => {
                            let routess = this.props.editRenewal ? '/renewals' : '/dashboard'
                            this.setState({ viewIssuePopUp: false })
                            if (this.props.history) {
                                this.props.history.push(routess)
                            } else {
                                window.location.href = `${routess}`
                            }
                        }}
                        buttonText="OK"

                    >
                        Thank you for issuing the quote; this will be emailed to you.
                    </PopUp>
                    : null}

                {this.state.confirmRemove ? (
                    <PopUp
                        title="Remove Quote Variant"
                        buttonText="Remove"
                        action={this.handleRemove}
                        numberButtons={2}
                        secondaryButtonText="Cancel"
                        secondaryAction={this.handleClosePopup}
                    >
                        Please confirm removal of this quote variant.
                    </PopUp>
                ) : null}

                {this.state.confirmCancel ? (
                    <PopUp
                        title="Cancel Renewal"
                        buttonText="Cancel"
                        action={this.handleRemove}
                        numberButtons={2}
                        secondaryButtonText="Edit"
                        secondaryAction={this.handleClosePopup}
                    >
                        Please confirm cancellation of this renewal quote.
                    </PopUp>
                ) : null}

                {this.state.boundPopupError ? (
                    <PopUp
                        title={`${this.state.boundTitle} Bound`}
                        buttonText={`Back to ${(this.state.boundTitle).toLowerCase()} list`}
                        action={() => this.handleEndRoute(this.state.boundTitle)}
                    >
                        {(this.state.boundTitle)} {(this.state.boundError).toLowerCase()}
                    </ PopUp>
                ) : null}
                {this.state.boundBind ? (
                    <PopUp
                        title={`${this.state.boundTitle} Bound`}
                        buttonText={`Back to ${(this.state.boundTitle).toLowerCase()} list`}
                        action={() => this.handleEndRoute(this.state.boundTitle)}
                    >
                        The {(this.state.boundTitle).toLowerCase()} has been bound
                    </ PopUp>
                ) : null}

                {this.state.confirmBind ? (
                    <BindContainer
                        handleClosePopup={this.handleClosePopup}
                        handleBind={this.handleBind}
                        handleEndRoute={this.handleEndRoute}
                        quoteId={this.props.quoteId}
                        varId={this.props.values.id}
                        values={this.props.values}
                        commission={this.state.commission}
                        excess={this.state.excess}
                        quoteData={this.props.quoteData}
                        isCollectors={false}
                        isMuseums={true}
                        isDealersStock={false}
                        isWineSpirits={false}
                        renewal={this.props.editRenewal}
                        checkRenewalStep02OnlyUpdate={this.props.checkRenewalStep02OnlyUpdate}
                        postIssuedQuotePopUp={() => {
                            if (this.props.editRenewal) {
                                this.props.history ?
                                    this.props.history.push('/renewals') : window.location.href = `/renewals`
                            } else {
                                this.props.history ?
                                    this.props.history.push('/dashboard') : window.location.href = `/dashboard`
                            }
                        }}
                    />
                ) : null}

                {this.state.confirmIssue ? (
                    <IssueContainer
                        handleClosePopup={this.handleClosePopup}
                        issuedQuotePopUp={() => this.setState({ viewIssuePopUp: true })}
                        postIssuedQuotePopUp={() => { this.setState({ viewIssuePopUp: true }) }}
                        renewal={this.props.editRenewal}
                        quoteId={this.props.quoteId}
                        values={this.props.values}
                        varId={this.props.values.id}
                    />
                ) : null}

                <div className="variation__header">
                    <div className="variation__title">
                        <h4>Quote 0{this.props.index + 1}</h4>
                    </div>
                    <div className="variation__result">
                        <div className="variation__result__text">Premium:</div>
                        <div className="variation__result__number">
                            £{this.props.values.premium} {get(values, 'refer') ? '*' : ''}
                        </div>
                        <div className="variation__result__text">inc.IPT and Fee</div>
                    </div>
                </div>

                {get(values, 'refer') && (
                    <div className="variation__indication">
                        <div className="indication_text">
                            This is an indication of premium only – please click the
                            <span>
                                {this.props.editRenewal ? ' invite renewal ' : ' issue quote '}
                            </span>
                            button below for underwriters to consider
                        </div>
                    </div>
                )}

                <div className="variation__adjustment">
                    <VariationCommission
                        onChange={this.handleAdjustChangecommission}
                        value={this.state.commission}
                        commissionList={this.props.commissionList}
                        maxCommission={this.props.maxCommission}
                        minCommission={this.props.minCommission}
                    />
                </div>

                <div className="variation__adjustment">
                    <VariationExcess
                        onChange={this.handleAdjustChangeExcess}
                        value={this.state.excess}
                        maxExcession={this.props.maxExcession}
                        minExcession={this.props.minExcession}
                    />
                </div>

                <div className="variation__options">
                    <VariationOptions
                        dirty={(dirtyVariationOption) => this.setState({ dirtyVariationOption })}
                        handleAdjustChangeOptions={this.handleAdjustChangeOptions}
                        toggleOptionsOpen={this.toggleOptionsOpen}
                        optionsOpen={this.state.optionsOpen}
                        values={this.props.values}
                    />
                </div>

                <div
                    className={`variation__actions
                        ${this.props.values.isIssued ? 'issued' : null}`}
                >
                    <button
                        className={`variation__actions__button
                        ${this.state.dirtyVariationOption || this.props.dirtySteps ? 'issued' : null}
                        ${editRenewal && !checkStep04update ? 'renewal_disable' : ''}`}
                        // className={`variation__actions__button ${this.props.values.isIssued ? 'issued' : null}`}
                        onClick={this.handleIssueButton}
                        type="button"
                        disabled={this.state.dirtyVariationOption || this.props.dirtySteps}
                    // disabled={this.props.values.isIssued}
                    >
                        <span>{`${(this.props.editRenewal) ? 'Invite renewal' : 'Issue quote'}`}</span>
                    </button>

                    <button
                        className={`variation__actions__button
                        ${(this.props.loading ||
                                this.state.dirtyVariationOption ||
                                this.props.dirtySteps) ? 'issued' : null}
                                ${editRenewal && !checkStep04update ? 'renewal_disable' : ''}`}
                        onClick={this.handleBindButton}
                        type="button"
                        disabled={this.state.dirtyVariationOption || this.props.loading || this.props.dirtySteps}
                    >
                        <span>Bind</span>
                    </button>

                    <button
                        className={`variation__actions__button
                        ${(this.disableRemoveButton()) ?
                                'issued' :
                                null}`
                        }
                        onClick={() => this.props.editRenewal ?
                            this.setState({ confirmCancel: true }) :
                            this.setState({ confirmRemove: true })}
                        type="button"
                        disabled={this.disableRemoveButton()}
                    >
                        <span>{`${(this.props.editRenewal) ? 'Cancel' : 'Remove'}`}</span>
                    </button>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05m/components/Variation.tsx